import Vue from 'vue';

export default [
    {
        pathId: 'sps',
        component: 'study-plans',
        title: 'Study Plans',
        icon: 'fa-clipboard-list-check',
        size: 'md',
        loading: true,
        reload: true
    },
    {
        pathId: 'sp',
        component: 'study-plan-detail',
        title: 'Study Plan',
        icon: 'fa-clipboard-list-check',
        size: 'lg',
        props: ['enrollmentId'],
        loading: true
    },
    {
        pathId: 'spr',
        component: 'study-plan-reject',
        title: 'Request Changes',
        icon: 'fa-comment-dots',
        size: 'md',
        props: ['enrollmentId'],
        loading: true
    }
];

Vue.component('study-plans', () => import('@/cards/study_plans/StudyPlans'));
Vue.component('study-plan-detail', () => import('@/cards/study_plans/StudyPlanDetail'));
Vue.component('study-plan-reject', () => import('@/cards/study_plans/StudyPlanReject'));
